import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * Legacy /vendor/:vendorId route redirects to the new public storefront.
 * shop_id is deterministic: `shop_{user_id}` (see backend/shop_domain.py).
 */
export default function VendorDetail() {
  const { vendorId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (vendorId) navigate(`/shop/shop_${vendorId}`, { replace: true });
  }, [vendorId, navigate]);
  return null;
}
